import queryString from 'query-string';

function stringify(params) {
  const order = ['solution', 'module', 'section', 'item'];
  return queryString.stringify(params, {
    sort: (a, b) => order.indexOf(a) - order.indexOf(b),
  });
}

export default {
  parse: queryString.parse,
  stringify,
};
